import { http } from "Utils/http";
import { Form, Col, Row, Spinner, Button } from 'react-bootstrap';
import {TextButton, IconTextButton, IconButton} from 'Components/Button';
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import {store} from 'Store';
import { useState, useEffect,useReducer } from "react";
import { useSelector, useDispatch } from "react-redux";
import {useParams, useLocation, useNavigate } from 'react-router-dom';
import { formatDate, isInObject } from "Utils/utilityFunctions";
import DatatableDropdownEntryField from "Components/Datatable/DatatableComponents/DatatableDropdownEntryField";
import DatatableDropdownCheckboxesField from "Components/Datatable/DatatableComponents/DatatableDropdownCheckboxesField";
import { FilterDrama } from "@mui/icons-material";
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES } from "Utils/constants";
import { httpDownload } from "Utils/httpDownload";
import Download from '@mui/icons-material/FileDownloadOutlined';
import { ICONS } from "Utils/icons";
import Event from "Components/Event/Event";
import DynamicFormPopup from "Components/Popup/DynamicFormPopup";
import Tag from "Components/Tag/Tag";
import parse from 'html-react-parser';



const UpcomingEvents = ({ ...props}) => {
    // Date format: mm/dd/yyyy hh: mm
    const loginInfo = useSelector(state => state.loginInfo);
    //console.log(loginInfo);

    let location = useLocation();
    
    const navigate = useNavigate();
    
    const dispatch = useDispatch();
  
    

    const [isLoading, setIsLoading] = useState(true);
    const [eventsData, setEventsData] = useState(null);

    const [viewEventId, setViewEventId] = useState(null);

    const hidePopup = (e) => {
        setViewEventId(null);  
    }
    const showPopup = (eventId) => {
        //console.log(eventId);
        setViewEventId(eventId);  
    }

    var popupButtons = [
        {
            text: "Attend Event",
            //action: handleAgree,
            variant: "normal",
            //disabled: feedbackCharCount < 1 || isFeedbackLoading==true ? true: false
        },
        {
            text: "Close",
            action: hidePopup,
            variant: "outline",
            //disabled: false
        }
    ]

    const handleGetEvents = async (e) => {
        var url = '/api/dashboard/getEvents';
        setIsLoading(true);
        const loginState = store.getState().loginInfo;
        //console.log(loginState);
        
        setEventsData(
            [
                    {
                        "eventId": 1,
                        "name": "AHRQ Quarterly Call Meeting",
                        "location": "Virtual",
                        "invited": "For Registered PSO",
                        "shortDesc": "This meeting is to discuss upcoming changes to the annual dashboard updating process. I am adding more text here to show that there is truncation.",
                        "longDesc": "This meeting is to discuss upcoming changes to the annual dashboard updating process. Below is some more copy just to show length of this section: <br></br>This group call will take place on Thursday, allowing participants to directly interact with industry professionals and gain valuable knowledge in the field of human resources.<br></br>During the call, our guest speakers will cover essential HR topics, addressing specific questions and facilitating discussions on key areas of interest. The format of the group call will be conference call, offering participants the opportunity to actively engage in a moderated discussion and Q&A session.<br></br>This event is tailored for HR professionals, managers, and business owners who seek practical advice and best practices in the HR domain.",
                        "date": 1761919200000,
                        "addedByUser": "Austin Hughes",
                        "updatedByUser": null,
                        "addedByUserId": null,
                        "updatedByUserId": null,
                        "addedOn": null,
                        "updatedOn": null
                    },
                    {
                        "eventId": 2,
                        "name": "Software Developers Meeting",
                        "location": "Virtual",
                        "invited": null,
                        "shortDesc": "This meeting is to discuss upcoming changes to the items available to developers. I am adding more text here to show that there is truncation.",
                        "longDesc": "This is a test description for <strong>Software Developers Meeting</strong>.",
                        "date": 1762095600000,
                        "addedByUser": "Austin Hughes",
                        "updatedByUser": null,
                        "addedByUserId": null,
                        "updatedByUserId": null,
                        "addedOn": null,
                        "updatedOn": null
                    },
                    {
                        "eventId": 3,
                        "name": "New PSO Profile Training",
                        "location": "Virtual",
                        "invited": "For Registered PSO",
                        "shortDesc": "This meeting is to help new PSOPPC members who want training. I am adding more text here to show that there is truncation.",
                        "longDesc": "This is a test description for <strong>New PSO Profile Training</strong>.",
                        "date": 1762354800000,
                        "addedByUser": "Austin Hughes",
                        "updatedByUser": null,
                        "addedByUserId": null,
                        "updatedByUserId": null,
                        "addedOn": null,
                        "updatedOn": null
                    }
                ]
        );
        /*const res = http.post(url, null,{
            timeout: 65000, // Set a timeout of 5 seconds,
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            //console.log(response);
            if(response != null ){
                var statusCode = response.status;
                if(statusCode != 1){
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true, 
                            title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                            msg: response.globalErrorMessageList != null && response.globalErrorMessageList.length>0 ? response.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                            showContactHelp: false 
                        },
                        redirect: {
                            redirect: false, 
                            redirectFirst: false,
                            path: "", 
                            data: {}
                        }
                    });
                }
                else {
                    //setEventsData([]);
                    setEventsData(response.data.allEvents);
    
                } 
                setIsLoading(false);
            }
            else{
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                        showContactHelp: true 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data: {}
                    }
                });
            }
            
        }).catch(function (error) {
            //console.log(error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                },
                error: error
            });
        });*/
        setIsLoading(false);
        //return res;
    };


    
    useEffect(()=>{
        handleGetEvents();
    },[])


    const formatEventCardDate = (time) => {
        if(time == null){
            return null;
        }
        else{
            let date = new Date(time);
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let hour = date.getHours();
            let min = date.getMinutes();
            
            let ampm = hour >= 12 ? 'PM' : 'AM';
            hour = hour % 12;
            hour = hour ? hour : 12; // The hour '0' should be '12'

            return (
                <div>
                    {date.toLocaleString('default', { hour12: 'true', hour: "numeric", minute: "2-digit"})}
                    {" - "}
                    {date.toLocaleString('default', { month: 'long',  day: 'numeric', year: 'numeric' })}
                </div>
            )
        }
  }
  const formatEventDate = (time) => {
        if(time == null){
            return null;
        }
        else{
            let date = new Date(time);
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let hour = date.getHours();
            let min = date.getMinutes();
            
            let ampm = hour >= 12 ? 'PM' : 'AM';
            hour = hour % 12;
            hour = hour ? hour : 12; // The hour '0' should be '12'

            return (
                <div>
                    {date.toLocaleString('default', { weekday: 'short'})}
                    {", "}
                    {date.toLocaleString('default', { day: 'numeric'})}
                    {" "}
                    {date.toLocaleString('default', { month: 'long', year: 'numeric' })}
                </div>
            )
        }
  }
  const formatEventTime = (time) => {
        if(time == null){
            return null;
        }
        else{
            let date = new Date(time);


            return (
                <div>
                    {date.toLocaleString('default', { hour12: 'true', hour: "numeric", minute: "2-digit"})}
                    
                </div>
            )
        }
  }

  
        
  return (
    <>
        
        {
            eventsData != null && isLoading == false
            ?   
                eventsData.length > 0 
                ?   
                        <Row className="public-cards justify-content-center row-gap-4 col-gap-3 mx-auto">
                        {
                            eventsData.map((event) => {
                                return (
                                <>
                                    <DynamicFormPopup
                                        showPopup = {viewEventId==event.eventId}
                                        handleClose = {hidePopup}
                                        buttons = {popupButtons}
                                        title = {"Meeting Details"}
                                        type= {"blank"}
                                        variant={"blank"}
                                    >
                                        <div className="ms-4 me-4 mt-2">
                                            <h5 className="event-name">{event.name}</h5>
                                            <p className="event-creator">Added by {event.addedByUser}</p>
                                            <div className="d-flex justify-content-between mt-4">
                                                <div className="d-flex column-gap-2">
                                                    {
                                                        [
                                                            {
                                                                text: event.location,
                                                                icon: ICONS.location
                                                            },
                                                            {
                                                                text: formatEventTime(event.date),
                                                                icon: ICONS.time
                                                            },
                                                            {
                                                                text: event.invited,
                                                                icon: ICONS.people
                                                            }
                                                        ].map((tag)=> {
                                                            if(tag.text!=null & tag.text!=""){
                                                                return <Tag text={tag.text} icon={tag.icon}></Tag>;
                                                            }
                                                            else {
                                                                return null;
                                                            }
                                                        })
                                                    }
                                                </div>
                                                <div className="">
                                                    {formatEventDate(event.date)}
                                                </div>
                                            </div>

                                            <hr></hr>
                                            
                                            <div className="d-flex gap-3">
                                                <div>
                                                    {ICONS.calendar()}
                                                </div>
                                                <div>
                                                    <h6 className="event-details-label mt-1">Event Details</h6>
                                                    
                                                    <p className="event-details">{/*parse(event.longDesc)*/}This meeting is to discuss upcoming changes to the annual dashboard updating process. Below is some more copy just to show length of this section: 
<br></br><br></br>
This group call will take place on Thursday, allowing participants to directly interact with industry professionals and gain valuable knowledge in the field of human resources. 
<br></br><br></br>
During the call, our guest speakers will cover essential HR topics, addressing specific questions and facilitating discussions on key areas of interest. The format of the group call will be conference call, offering participants the opportunity to actively engage in a moderated discussion and Q&A session. 
<br></br><br></br>
This event is tailored for HR professionals, managers, and business owners who seek practical advice and best practices in the HR domain.</p>
                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                    </DynamicFormPopup>
                                    <Event
                                        name={event.name}
                                        tags={
                                            [
                                                {
                                                    text: event.location,
                                                    icon: ICONS.location
                                                },
                                                {
                                                    text: event.invited,
                                                    icon: ICONS.people
                                                }
                                            ]
                                        }
                                        description={event.shortDesc}
                                        date={formatEventCardDate(event.date)}//"10:00 AM – October 31, 2025"
                                        buttons={[
                                            {
                                                text: "Attend",
                                                //action: handleAgree,
                                                className:"w-100 event-btn",
                                                variant: "normal",
                                                //disabled: false
                                            },
                                            {
                                                text: "View",
                                                action: ()=>showPopup(event.eventId),
                                                className: "event-btn",
                                                variant: "outline",
                                                //disabled: false
                                            }
                                        ]}
                                    ></Event>
                                </>
                                    
                                )
                            })
                        }
                        </Row>

                    /*<div >
                        <Row className="d-flex events row col-gap-2 row-gap-3 col-12 flex-column flex-md-row align-items-center align-items-md-baseline justify-content-md-center">
                        {
                            eventsData.map((event) => {
                                return (
                                <>
                                    <DynamicFormPopup
                                        showPopup = {viewEventId==event.eventId}
                                        handleClose = {hidePopup}
                                        buttons = {popupButtons}
                                        title = {"Meeting Details"}
                                        type= {"blank"}
                                        variant={"blank"}
                                    >
                                        <div className="ms-4 me-4 mt-2">
                                            <h5 className="event-name">{event.name}</h5>
                                            <p className="event-creator">Added by {event.addedByUser}</p>
                                            <div className="d-flex justify-content-between mt-4">
                                                <div className="d-flex column-gap-2">
                                                    {
                                                        [
                                                            {
                                                                text: event.location,
                                                                icon: ICONS.location
                                                            },
                                                            {
                                                                text: formatEventTime(event.date),
                                                                icon: ICONS.time
                                                            },
                                                            {
                                                                text: event.invited,
                                                                icon: ICONS.people
                                                            }
                                                        ].map((tag)=> {
                                                            if(tag.text!=null & tag.text!=""){
                                                                return <Tag text={tag.text} icon={tag.icon}></Tag>;
                                                            }
                                                            else {
                                                                return null;
                                                            }
                                                        })
                                                    }
                                                </div>
                                                <div className="">
                                                    {formatEventDate(event.date)}
                                                </div>
                                            </div>

                                            <hr></hr>
                                            
                                            <div className="d-flex gap-3">
                                                <div>
                                                    {ICONS.calendar()}
                                                </div>
                                                <div>
                                                    <h6 className="event-details-label mt-1">Event Details</h6>
                                                    
                                                    <p className="event-details">{parse(event.longDesc)}</p>
                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                    </DynamicFormPopup>
                                    <Event
                                        name={event.name}
                                        tags={
                                            [
                                                {
                                                    text: event.location,
                                                    icon: ICONS.location
                                                },
                                                {
                                                    text: event.invited,
                                                    icon: ICONS.people
                                                }
                                            ]
                                        }
                                        description={event.shortDesc}
                                        date={formatEventCardDate(event.date)}//"10:00 AM – October 31, 2025"
                                        buttons={[
                                            {
                                                text: "Attend",
                                                //action: handleAgree,
                                                className:"w-100",
                                                variant: "normal",
                                                //disabled: false
                                            },
                                            {
                                                text: "View",
                                                action: ()=>showPopup(event.eventId),
                                                variant: "outline",
                                                //disabled: false
                                            }
                                        ]}
                                    ></Event>
                                </>
                                    
                                )
                            })
                        }
                        </Row>
                    </div>*/

                :   <div className="no-events">
                        <p>No Events Scheduled</p>
                    </div>

            :   null
        }

    </>
  );
}

export default UpcomingEvents;